import { today, yesterday } from '../../../utils/dateUtils';

export interface AnaliticEvent {
  ID: number;

  DI: DateInfo;
  Date: DateInfo;
  DateEvent: DateInfo;
  NextControl: DateInfo;

  ID_Type: number;
  ID_Parent: number | null;
  ID_Device: number;

  Priority: number;
  Quality: number;
  Author: string;
  Status: string;
  Source: string | null;
  Value: string;
  Unit: string;
  Tags: string;
  Rem: string;

  EventType: string;

  DeviceType: string;
  ID_Obj: number;
  ID_ObjParent: number;
  ID_DevType: number;
  ID_DevKind: number;

  DeviceName: string;
  DevicePlace: string;
  DeviceModel: string;
  DeviceNum: string;
  DeviceVal: string;
  DeviceRem: string;
  DeviceKindName: string;

  ObjName: string;
  ObjCode: string;
  ObjAddress: string;
  ObjCity: string;

  ObjParentName: string;
  ObjParentCode: string;
}

export interface DateInfo {
  date: string;
  timezone_type: number;
  timezone: string;
}

export type AnaliticFilterItemType = 'Start' | 'Finish';

export interface IAnaliticFilter {
  type: AnaliticFilterItemType | 'index';
  value: string | string[];
}

export const analiticDefaultFilter: IAnaliticFilter[] = [
  { type: 'Start', value: yesterday.format('YYYY-MM-DD') },
  { type: 'Finish', value: today.format('YYYY-MM-DD') },
];

export interface AnaliticStore {
  filter: IAnaliticFilter[];
  currentAnaliticAction: AnaliticEvent | null;
}

export interface IFile {
  ID: number;
  base64: string;
}
